<script>
export default {
  name: 'LoadingRing',
};
</script>

<template lang="pug">
i.loading-ring-alt.h1.w1.relative.db

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";

.loading-ring-alt {
  animation: rotateRingAlt 0.8s infinite linear;
  border-width: 0.2rem;
  border-style: solid;
  border-right-color: transparent;
  border-radius: 50%;
}

@keyframes rotateRingAlt {
  0%    { transform: rotate(0deg); }
  100%  { transform: rotate(360deg); }
}

</style>
